<template>
  <div>
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        :text= "this.$t('mapmenu')"
        icon="network-wired"
        color="bg-pastel-purple"
      />
      {{$t('layerselection')}}
      {{$t('animationselection')}}
    </l-container>
    <div class="grid grid-cols-3">
      <div class="col-span-2">
        <LLayerSelection :playingAnim="playingAnim" @click="onSelectionClick"/>
      </div>
      <div class="col-span-2">
        <div class="grid grid-cols-3">
          <div id="menu" class="col-span-2" style=" float:left;margin-top: 1%;">
            
            <input id="light-v10" type="radio" name="rtoggle" value="light" checked="checked" style="margin-left: 3%;">
            <label for="light-v10" style="margin-left: 0.2%;">Light</label>
            <input id="satellite-v9" type="radio" name="rtoggle" value="satellite" style="margin-left: 1.5%;">
            <label for="satellite-v9" style="margin-left: 0.2%;">Satellite</label>
            <input id="dark-v10" type="radio" name="rtoggle" value="dark" style="margin-left: 1.5%;">
            <label for="dark-v10" style="margin-left: 0.2%;">Dark</label>
            <input id="streets-v11" type="radio" name="rtoggle" value="streets" style="margin-left: 1.5%;">
            <label for="streets-v11" style="margin-left: 0.2%;">Streets</label>
            <input id="outdoors-v11" type="radio" name="rtoggle" value="outdoors" style="margin-left: 1.5%;">
            <label for="outdoors-v11" style="margin-left: 0.2%;">Outdoors</label>
            <input id="navigation-night-v1" type="radio" name="rtoggle" value="navigation" style="margin-left: 1.5%;">
            <label for="navigation-night-v1" style="margin-left: 0.2%;">Navigation</label>
          </div>
          <div id="geocoder" class="geocoder;col-span-3" style="margin-left: 15%;"></div>
        </div>
        <div id='map'>
        </div>        
      </div>
      <div>
        <div v-show="loading">
          <div class="flex justify-center items-center">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
          </div>
          <div class="flex justify-center items-center">{{$t("dataloading")}}</div>
        </div>
        <Layers :layers="layers" id= "testid" v-on:checklayer="onLayerSelect" v-on:downloadlayer="onDownloadLayer" v-on:removelayer="onLayerRemove"/>
        <div v-if="MapTime" class="timedisplay bg-gray-500 text-center text-lg text-white">{{MapTime}}</div>
        <SensorStatus :selectedSensor="selectedSensor" :ssfeature="feature" :ssH24Parameters="Aqparameters.H24Parameters" :measurementStatus="true" :placementStatus="false"></SensorStatus>
        
      </div>
    </div>
  </div>
</template>

<script>


import mapboxgl from 'mapbox-gl'
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import SensorsService from "../../../helpers/apiservices/sensors/sensors.service";
import MapboxglSettings from "../../../helpers/settings/mapboxgl";
import ObservationsService from "../../../helpers/apiservices/observations/observations.service";
import GeoJSONWrapper from "../../../helpers/geojsonwrapper";
//Helpers
import Aqparameters from "../../../helpers/settings/aqparameters"; 
import ObservationStatus from "../../../helpers/observationstatus"; 
import MapboxglHelper from "@/helpers/mapboxglhelper";

//Components
import LLayerSelection from "../../../views/viewer/LLayerSelection";
import Layers from './Layers';
import SensorStatus from './SensorStatus';

import {Legendgraphics} from '../../../components/controls/mapboxcontrols'
import GeoserverHelper from '../../../helpers/geoserver' 
import * as moment from "moment";
import Vue from 'vue'

require('mapbox-gl/dist/mapbox-gl.css');

//Variables for map
var map;
var sensors;
var disabledSensors;
const DEFAULTLAYERDS = "Disabled sensors";
var sourceandlayers = [];

const selected = Vue.observable({sensor: {}}); 
const mbfeature = Vue.observable({feature: {}}); 

export default {

name: 'SensorsMap',
components: {
  LLayerSelection,
  Layers,
  SensorStatus
},
data() {
  return {
    sensors: [],
    disabledsensors:[],
    playingAnim: false,
    loading: false,
    layers: {
      placementlayers: [],
      maplayers:[],
      measurementlayers:[]
    },
    Aqparameters: Aqparameters.settings() ,
    controls: [],
  };
},
mounted() {
  //Testing without using Notify
  //Notify.loadData(null, this.loadInitialData);
  this.loading = true;
  this.loadInitialData();
},
methods: {
  async loadInitialData() { 

    //Map create
    this.map();
    await (this.mapReady || Promise.resolve());
    
    //Get all sensors
    this.sensors = await SensorsService.sensors();
    sensors = this.sensors; //variable for mapbox gl js for all sensors

    //Check sensor status based on different parmameters (online, qc flags, mobile/static/disabled sensor)
    await this.addStatus();

    //Place disabled sensors in its own layer
    this.loadDisabledSensors();

    //Load Measurements- mobile sensors
    this.loadMobileSensorMeasurements();

    //Load Measurements- static sensors
    this.loadStaticSensorMeasurements();

    //Turn off loader
    this.loading = false;
  },

  async loadStaticSensorMeasurements(){

    const sensorscomp = [];
    let onlineSensors = this.staticSensors.filter( s => s.onlinedata); 

    //sensor.onlinedata = true;
    onlineSensors.forEach((s) => {
      this.Aqparameters.LastHourParameters.forEach((c) => {
        sensorscomp.push({"SensorId" : s.id, "SensorName": s.name, "Component": c.name, "ProviderId": s.provider.id});
      });
    });

    const filtering = {
      From: moment().utc().subtract(2, 'hours').unix(), 
      To : moment().utc().unix(), 
      AggLevel: 'hourly',
      Sensors: sensorscomp
    };

    this.loading = true;
    let obs = await ObservationsService.aggregeatedobservations(filtering);


    //Create one layer for each of the defined parameters
    this.Aqparameters.LastHourParameters.forEach(param => {

      //Only static sensors that have this component registered
      let compsensors = onlineSensors.filter(cs => cs.components.some(c=> c.name === param.name)); 

      let compsensorobs =  obs.filter( o => {
          if(o.component == param.name && compsensors.some(cs => cs.id === o.id)){return true;}
          return false;
        });

      var msobs = GeoJSONWrapper.wrapStaticSensorLastMeasurements(
        obs.filter( o => {
          if(o.component == param.name && compsensors.some(cs => cs.id === o.id)){return true;}
          return false;
        }),
        onlineSensors);

      MapboxglHelper.addCircleClusterValueSourceAndLayer(
        this.addSourceAndLayer(msobs, 'lastmeasurement' + param.name, param.layername, 'none', 'clustercircle', param.colorcodes), //stores in variable and returns the object
        map
      );

      //Custom event for showing sensor status with measurements for the last 24H, right side on screen 
      map.on('click', `${param.layername}_layer`, function(e) {
        var features = map.queryRenderedFeatures(e.point, { layers: [`${param.layername}_layer`] });
        var point_count = features[0].properties.point_count;
        let numbers = parseInt(point_count) ? parseInt(point_count) : 0;
        //If just showing one - add as selected sensor to show graphs
        if(numbers === 0 ){
          var ss =  sensors.find(s => {return s.id === features[0].properties.id});
              selected.sensor = ss;
              mbfeature.feature = features[0];
        }
      });

      //Add filtering options - binding for Layer component
      this.layers.measurementlayers.push({'name': param.layername, 'checked': false}); 

      this.loading = false;

    });
  },
  async loadMobileSensorMeasurements(){

    //Get observations
    await Promise.all(this.mobileSensors.map(async (sensor) => {
      let filter = {
          datefrom: moment().utc().subtract(1, 'days').unix(), 
          dateto : moment().utc().unix(), 
          sensorid: sensor.id,
          providerid : sensor.provider.id
        };
      
      this.loading = true;
      let obs = await ObservationsService.sensorobservationsTS(filter);

      //Create sensor property for all data for the last 24 hours for each defined parameter 
      this.Aqparameters.H24Parameters.forEach(param => {
        sensor['last24obs' + param.name] = obs.filter( o => o.component === param.name); 
      });

    }));

    //Create one layer for each of the defined parameters
    this.Aqparameters.H24Parameters.forEach(param => {
      var msobs = GeoJSONWrapper.wrapmobilesensors24hobs(this.mobileSensors, 'last24obs' + param.name);
      MapboxglHelper.addCircleValueSourceAndLayer(
        this.addSourceAndLayer(msobs, 'mobilesensorobs' + param.name, param.layername, 'none', 'circle', param.colorcodes), //stores in variable and returns the object
        map
      );

      //Custom event for showing sensor status with measurements for the last 24H, right side on screen 
      map.on('click', `${param.layername}_layer`, function(e) {
        var features = map.queryRenderedFeatures(e.point, { layers: [`${param.layername}_layer`] });
        var point_count = features[0].properties.point_count;
        let numbers = parseInt(point_count) ? parseInt(point_count) : 0;
        //If just showing one - add as selected sensor to show graphs
        if(numbers === 0 ){
          var ss =  sensors.find(s => {return s.id === features[0].properties.id});
              selected.sensor = ss;
              mbfeature.feature = features[0];
        }
      });

      //Add filtering options - binding for Layer component
      this.layers.measurementlayers.push({'name': param.layername, 'checked': false}); 
      
      this.loading = false;
    });
  },

  loadDisabledSensors: function(){

    this.loading = true;

    this.disabledsensors = this.sensors.filter(function(v, i, a){return !v.enabled});
    disabledSensors = this.disabledsensors; //variable used for map events, copy of vue data variable
    this.sensors = this.sensors.filter(function(v, i, a){return v.enabled});

    //Create a layer of the disabled sensors
    var jsondatasource = GeoJSONWrapper.wrapsensors(this.disabledsensors);
    //var sourcelayer = 
    MapboxglHelper.addSymbolSourceAndLayer(
      this.addSourceAndLayer(jsondatasource, 'disabledsensors', DEFAULTLAYERDS, 'none', 'symbol',''), //stores in variable and returns the object
      map
      );

    //Add filtering options - binding for Layer component
    this.layers.measurementlayers.push({'name': DEFAULTLAYERDS, 'checked': false}); 

    this.loading = false;

  },

  map: function (layers) {

    //set mapbox keys and init
    mapboxgl.accessToken = MapboxglSettings.accessToken.key; 
    map = new mapboxgl.Map(MapboxglSettings.map);

    //expose a promise on the component instance that resolves when map is ready
    this.mapReady = new Promise((resolve) => { this._mapReadyResolve = resolve; });

    // Initialize the search
    const geocoder = new MapboxGeocoder({
        
        accessToken: mapboxgl.accessToken, // Set the access token
        mapboxgl: mapboxgl, // Set the mapbox-gl instance
        marker: false, // Do not use the default marker style
        placeholder: this.$t('searchplace')
      });
    document.getElementById('geocoder').appendChild(geocoder.onAdd(map));

    //Changes style - event
    const layerList = document.getElementById('menu');
    const inputs = layerList.getElementsByTagName('input');
    for (const input of inputs) {
        input.onclick = (layer) => {
          const layerId = layer.target.id;
          map.setStyle('mapbox://styles/mapbox/' + layerId + '?fresh=true');
        };
    } 

    //Need to recreate all sources and layers when new style is added
    //use arrow functions so `this` refers to the Vue component and can resolve the promise
    map.on('style.load', () => {
      MapboxglHelper.recreatesourceandlayer(sourceandlayers, map);
      if (this._mapReadyResolve) { this._mapReadyResolve(); this._mapReadyResolve = null; }
    });

    //Also resolve a map-ready promise once the map itself has emitted 'load'
    map.on('load', () => {
      if (this._mapReadyResolve) { this._mapReadyResolve(); this._mapReadyResolve = null; }
    });

    // Handle missing images in style (add them dynamically)
    map.on('styleimagemissing', (e) => {
      try {
        MapboxglHelper.loadmissingimages(e, map);
      } catch (err) {
        // ignore to avoid breaking map initialization
        console.error('Failed to load missing style image', err);
      }
    });

    //Set map attributes
    map.addControl(new mapboxgl.AttributionControl({
      customAttribution: 'The maps make partial use of open uEMEP data, whose provision by MET Norway is gratefully acknowledged'
    }));

  },

  //Store sources and layers that are added on the map in a variable for map to use in events
  //This will be used for recreation of sources and layers when the style is changed
  addSourceAndLayer: function(jsondata, sourcename, layername, visibility, type, colorcodes){
    var sourcelayer = {
      jsondata: jsondata,
      sourcename: sourcename,
      layername: layername,
      visibility: visibility,
      type: type,
      colorcodes: colorcodes
    }
    sourceandlayers.push(sourcelayer); 
    return sourcelayer;
  },

  async addStatus(){
    
    let obs = await ObservationsService.observationsasync();
    let sensorobs = obs.filter((e, i) => obs.findIndex(a => a["id"] === e["id"]));

    this.sensors.forEach(sensor => {
      sensor.statustext = [];
      sensor =  ObservationStatus.setStatus(sensor, obs, sensorobs);

    });
  },

  //Event emitted from Layer component
  async onLayerSelect(e) { 
    MapboxglSettings.onLayerSelect(e, map);
    //Update list of source and layers
    var layer = sourceandlayers.find((sourceandlayer) => sourceandlayer.layername==e.name);
    layer.visibility = e.checked ? 'visible' : 'none';
  },

  //Event emitted from Layer component
  async onLayerRemove(e) { 
    //remove layer, source and from the layout list
    MapboxglSettings.onLayerRemove(`${e.name}_layer`, `${e.name}_source`, map); 

    //Only maplayers can be removed
    if(this.layers.maplayers.find(function(v, i, a){return v.name == e.name}) !== null){
      sourceandlayers = sourceandlayers.filter(function(v, i, a){return v.layername !== e.name});
      this.layers.maplayers = this.layers.maplayers.filter(function(v, i, a){return v.name !== e.name});
    } 
  },

  async onDownloadLayer(e) {  
  },


  //******************* For animation ***************************
  async onSelectionClick(selections) {  
    switch (selections.filtering) {
      case "single":
        this.addMapLayer(selections);
        break;
      case "animation":
        this.addMapAnimation(selections);
        break;
      case "clear":
        this.clearMapAnimation(selections);
        break;
      default:
        break;
    }
  },
  addMapLayer: function(selections){
    const name = `${selections.layer}_${selections.component}_${selections.to}`;
    //avoid duplicate layers
    if(!this.layers.maplayers.some(l => l.name === name)){
      this.layers.maplayers.push({
        'name': name, 
        'checked': true, 
        'selections': selections
      });

      MapboxglHelper.addMapLayer(
        this.addSourceAndLayer([GeoserverHelper.SingleMap(selections).url], name, name, 'visible', 'map',''), //stores in variable and returns the object
        map
      );
    }
    this.addLegendGraphics(selections); 
  },
  addLegendGraphics(selections){
    if(!this.controls.some(e => e.component === selections.component)){
      let legendgraphics = new Legendgraphics(selections.layer, selections.defaultstyle, selections.component);
      this.controls.push(legendgraphics);
      map.addControl(legendgraphics, 'top-left' );
    }
  },
  addMapAnimation: function(selections){
    //remove prevous animation layers
    MapboxglSettings.onLayerRemove(`${selections.layer}_animl`, `${selections.layer}_anims`, map); 
    
    this.currentAnimTime = moment(selections.from).utc().toISOString();
    this.playingAnim = true;

    map.addSource(`${selections.layer}_anims` , MapboxglSettings.imagesource(this.getMapPath(selections), selections));
    map.addLayer(MapboxglSettings.rasterlayer(`${selections.layer}_animl`, `${selections.layer}_anims`));
    map.flyTo({center: [(selections.latlonboundingbox.maxx + selections.latlonboundingbox.minx)/2, 
      (selections.latlonboundingbox.maxy + selections.latlonboundingbox.miny)/2], zoom: 11});

    this.addLegendGraphics(selections);

      //Update the image by creating a new url with the next hour,
    this.intervalid = setInterval(() => {
      if(this.currentAnimTime === selections.to){ //Stop adding new images when the stop time is matching
        clearInterval(this.intervalid);  
        this.playingAnim = false;  
      }
      else
      {
        map.getSource(`${selections.layer}_anims`).updateImage({ url: this.getMapPath(selections) });
        this.currentAnimTime = moment(this.currentAnimTime).add(1, 'hours').utc().toISOString();
      }
    },1500);
  },
  clearMapAnimation: function(selections){
    //remove prevous animation layers
    MapboxglSettings.onLayerRemove(`${selections.layer}_animl`, `${selections.layer}_anims`, map);
  },
  getMapPath : function (selections) {
      return (
        GeoserverHelper.SingleMapBbox(selections, this.currentAnimTime).url
      );
  },
  
},
computed:{
  MapTime: function(){
    if(this.currentAnimTime){
      return moment(this.currentAnimTime).format("DD MM YYYY HH:mm");  
    }
    return '';
  },
  selectedSensor(){
     return selected.sensor;
  },
  feature(){
     return mbfeature.feature;
  },
  staticSensors(){
    return this.sensors.filter(sensor=> {return sensor.staticsensor});
  },
  mobileSensors(){
    return this.sensors.filter(sensor=> {return !sensor.staticsensor});
  }
}
};
</script>

<style lang="postcss">

/* purgecss start ignore */
.geocoder {
  position: absolute;
  z-index: 1;
  width: 50%;
  left: 50%;
  margin-left: -25%;
  top: 10px;
}
.mapboxgl-ctrl-geocoder {
  min-width: 100%;
}
#map {
  width: 65%;
  height: 70%;
  position: absolute;
  
}
.mappopups {
  width: 800px;
}
.mapboxgl-popup mapboxgl-popup-anchor-bottom{
  max-width: 500px;
}
.timedisplay
{
  height: 30px;
  width: 175px;
  right: 0;
  left: 0;
  margin-right: 60%;
  margin-left: auto;
  margin-top: 10px;
  position: absolute;
}

/* purgecss end ignore */
#loader {
  position: absolute;
  z-index: 1;
  width: 35px;
  height: 35px;
  
  border: 5px solid #d7d2d2;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s
}

@-webkit-keyframes animatebottom {
  from { bottom:-100px; opacity:0 } 
  to { bottom:0px; opacity:1 }
}

@keyframes animatebottom { 
  from{ bottom:-100px; opacity:0 } 
  to{ bottom:0; opacity:1 }
}

</style>

<style lang="postcss">
@import 'https://api.mapbox.com/mapbox-gl-js/v1.8.1/mapbox-gl.css';
</style>